export enum Language {
  EN = 'en',
  TR = 'tr',
  KU = 'ku',
  AR = 'ar',
}
